'use client';

export default function BookAirbnbButton({
  airbnbUrl,
  propertyName,
  label = 'Book on Airbnb',
}: {
  airbnbUrl: string;
  propertyName: string;
  label?: string;
}) {
  return (
    <section className="py-6 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <a
          href={airbnbUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#9B7B3A] text-white font-[family-name:var(--font-outfit)] text-sm font-semibold uppercase tracking-[0.1em] hover:bg-[#C4A95E] transition-colors duration-300"
          onClick={() => {
            if (typeof window !== 'undefined' && 'gtag' in window) {
              (window as unknown as { gtag: (...args: unknown[]) => void }).gtag('event', 'book_airbnb_click', { property: propertyName });
            }
          }}
        >
          {label}
        </a>
      </div>
    </section>
  );
}
